import React, { useState, useEffect } from 'react';
import './ContactUs.css';
import Footer from './Footer';
// import { Link } from 'react-router-dom';
import Header from './Header';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [successMessage, setSuccessMessage] = useState('');
  const [gameWon, setGameWon] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [board, setBoard] = useState(Array(4).fill().map(() => Array(4).fill(0)));

  // Inicializar o jogo 2048
  useEffect(() => {
    initializeBoard();
  }, []);

  const initializeBoard = () => {
    let newBoard = Array(4).fill().map(() => Array(4).fill(0));
    addNewTile(newBoard);
    addNewTile(newBoard);
    setBoard(newBoard);
    setGameWon(false);
    setGameOver(false);
  };

  const addNewTile = (board) => {
    let emptyTiles = [];
    for (let i = 0; i < 4; i++) {
      for (let j = 0; j < 4; j++) {
        if (board[i][j] === 0) emptyTiles.push({ x: i, y: j });
      }
    }
    if (emptyTiles.length > 0) {
      const { x, y } = emptyTiles[Math.floor(Math.random() * emptyTiles.length)];
      board[x][y] = Math.random() > 0.1 ? 2 : 4;
    }
  };

  const handleKeyPress = (e) => {
    if (gameWon || gameOver) return;
    let newBoard = board.map(row => [...row]);
    let moved = false;

    if (e.key === 'ArrowUp') moved = moveUp(newBoard);
    if (e.key === 'ArrowDown') moved = moveDown(newBoard);
    if (e.key === 'ArrowLeft') moved = moveLeft(newBoard);
    if (e.key === 'ArrowRight') moved = moveRight(newBoard);

    if (moved) {
      addNewTile(newBoard);
      setBoard(newBoard);
      if (checkWin(newBoard)) {
        setGameWon(true);
        alert('Parabéns! Você venceu o jogo 2048! Agora pode enviar sua mensagem.');
      } else if (checkGameOver(newBoard)) {
        setGameOver(true);
        alert('Fim de jogo! Não há mais movimentos possíveis. Reinicie para tentar novamente.');
      }
    }
  };

  const moveLeft = (board) => {
    let moved = false;
    for (let i = 0; i < 4; i++) {
      let row = board[i].filter(val => val !== 0);
      for (let j = 0; j < row.length - 1; j++) {
        if (row[j] === row[j + 1]) {
          row[j] *= 2;
          row[j + 1] = 0;
          moved = true;
        }
      }
      row = row.filter(val => val !== 0);
      while (row.length < 4) row.push(0);
      if (board[i].join() !== row.join()) moved = true;
      board[i] = row;
    }
    return moved;
  };

  const moveRight = (board) => {
    let moved = false;
    for (let i = 0; i < 4; i++) {
      let row = board[i].filter(val => val !== 0);
      for (let j = row.length - 1; j > 0; j--) {
        if (row[j] === row[j - 1]) {
          row[j] *= 2;
          row[j - 1] = 0;
          moved = true;
        }
      }
      row = row.filter(val => val !== 0);
      while (row.length < 4) row.unshift(0);
      if (board[i].join() !== row.join()) moved = true;
      board[i] = row;
    }
    return moved;
  };

  const moveUp = (board) => {
    let moved = false;
    for (let j = 0; j < 4; j++) {
      let col = [];
      for (let i = 0; i < 4; i++) if (board[i][j] !== 0) col.push(board[i][j]);
      for (let k = 0; k < col.length - 1; k++) {
        if (col[k] === col[k + 1]) {
          col[k] *= 2;
          col[k + 1] = 0;
          moved = true;
        }
      }
      col = col.filter(val => val !== 0);
      while (col.length < 4) col.push(0);
      for (let i = 0; i < 4; i++) {
        if (board[i][j] !== col[i]) moved = true;
        board[i][j] = col[i];
      }
    }
    return moved;
  };

  const moveDown = (board) => {
    let moved = false;
    for (let j = 0; j < 4; j++) {
      let col = [];
      for (let i = 0; i < 4; i++) if (board[i][j] !== 0) col.push(board[i][j]);
      for (let k = col.length - 1; k > 0; k--) {
        if (col[k] === col[k - 1]) {
          col[k] *= 2;
          col[k - 1] = 0;
          moved = true;
        }
      }
      col = col.filter(val => val !== 0);
      while (col.length < 4) col.unshift(0);
      for (let i = 0; i < 4; i++) {
        if (board[i][j] !== col[i]) moved = true;
        board[i][j] = col[i];
      }
    }
    return moved;
  };

  const checkWin = (board) => {
    for (let i = 0; i < 4; i++) {
      for (let j = 0; j < 4; j++) {
        if (board[i][j] === 2048) return true;
      }
    }
    return false;
  };

  const checkGameOver = (board) => {
    // Verificar se há espaços vazios
    for (let i = 0; i < 4; i++) {
      for (let j = 0; j < 4; j++) {
        if (board[i][j] === 0) return false;
      }
    }

    // Verificar se há movimentos possíveis (tiles adjacentes iguais)
    for (let i = 0; i < 4; i++) {
      for (let j = 0; j < 4; j++) {
        if (i < 3 && board[i][j] === board[i + 1][j]) return false; // Verificar vertical
        if (j < 3 && board[i][j] === board[i][j + 1]) return false; // Verificar horizontal
      }
    }

    return true;
  };

  const handleRestart = () => {
    initializeBoard();
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [board, gameWon, gameOver]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!gameWon) {
      alert('Você precisa vencer o jogo 2048 para enviar a mensagem!');
      return;
    }
    setSuccessMessage('Mensagem enviada com sucesso! Entraremos em contato em breve.');
    setFormData({ name: '', email: '', message: '' });
    setTimeout(() => setSuccessMessage(''), 3000);
    handleRestart(); // Reiniciar o jogo após enviar a mensagem
  };

  return (
    <div>
      {/* Head */}
      {/* <section className="head">
        <div className="container flexSB">
          <div className="logo">
            <img src="/images/Asset7.png" alt="Academia Logo" className="logo-img" />
            <span>O Conteúdo que Precisas</span>
          </div>
          <div className="social">
            <i className="fab fa-facebook-f icon"></i>
            <i className="fab fa-instagram icon"></i>
            <i className="fab fa-twitter icon"></i>
            <i className="fab fa-youtube icon"></i>
          </div>
        </div>
      </section> */}

      {/* Header */}
      {/* <header>
        <nav className="flexSB">
          <ul className="flexSB">
            <li><a href="/">Início</a></li>
            <li><a href="/quem-somos">Quem Somos</a></li>
            <li><a href="/conteudo">Conteúdo</a></li>
            <li><a href="/contacto">Contacte-nos</a></li>
            <li><a href="/contacto">Baixe Coisas</a></li>
          </ul>
          <div className="start">
            <a href="/login" className="button">Iniciar Sessão</a>
          </div>
        </nav>
      </header> */}
            {/* <header>
            <nav className="flexSB">
              <ul className="flexSB">
                <li><Link to="/">Início</Link></li>
                <li><Link to="/AboutUs">Quem Somos</Link></li>
                <li><Link to="/ContentPage">Conteúdo</Link></li>
                <li><Link to="/ContactUs">Contacte-nos</Link></li>
                <li><Link to="/Downloads">Baixe Coisas</Link></li>
              </ul>
              <div className="start">
                <Link to="/Login" className="button">Iniciar Sessão</Link>
              </div>
            </nav>
          </header> */}
          <Header/>
      {/* Seção Contacte-nos */}
      <section className="contact-us-section">
        <div className="container">
          <h2>Contacte-nos</h2>
          <p className="contact-subtitle">
            Estamos aqui para ajudar! Envie sua mensagem e entraremos em contato o mais rápido possível. Para enviar a mensagem, vença o jogo 2048!
          </p>
          {successMessage && <p className="success-message">{successMessage}</p>}
          <div className="contact-content">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Nome:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">E-mail:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Mensagem:</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit" className="submit-btn" disabled={!gameWon}>
                Enviar Mensagem
              </button>
            </form>
            <div className="game-section">
              <h3>Jogo 2048</h3>
              <p>Use as setas do teclado para mover os tiles. Combine números iguais até chegar a 2048!</p>
              <div className="game-board">
                {board.map((row, i) => (
                  <div key={i} className="game-row">
                    {row.map((tile, j) => (
                      <div key={`${i}-${j}`} className={`game-tile tile-${tile}`}>
                        {tile !== 0 ? tile : ''}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              {(gameWon || gameOver) && (
                <button className="restart-btn" onClick={handleRestart}>
                  Reiniciar Jogo
                </button>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ContactUs;